import React from 'react';
import {useMutation} from 'react-query';
import {DocumentPicker, writeItem} from '../../api';
import {Button, List, TextInput} from 'react-native-paper';
import {useAppDispatch, useAppSelector} from '../../store/hooks';
import {setEditingParams} from '../../store/slices/shop';
import {Product} from '../../types';
import {IShopConfig} from '../../types/shop';
import {DocumentPickerAsset} from 'expo-document-picker';
import {pinFileToIPFS} from '../../api/pin';

export function ShopProductParams<T extends Product | IShopConfig>({
  product,
  productKey,
  title,
  staticParam,
  left,
  isFileSelector,
}: {
  product: T;
  productKey: keyof T;
  title: string;
  staticParam?: boolean;
  left?: () => React.ReactNode;
  isFileSelector?: boolean;
}) {
  const value = product ? product[productKey] : undefined;
  const isEditing = useAppSelector(
    state =>
      state.shop.editingParams[product?.id] &&
      state.shop.editingParams[product?.id][productKey as string],
  );
  const dispatch = useAppDispatch();
  const icon = isEditing ? 'checkbox-outline' : 'pencil-outline';
  const mutateValue = useMutation(async (newvalue: string) => {
    if (
      typeof product[productKey] === 'number' ||
      typeof value === 'number'
    ) {
      product[productKey] = parseFloat(newvalue);
    } else {
      product[productKey] = newvalue;
    }
    return await writeItem(product);
  });
  const titleParam = isEditing ? (
    <TextInput
      value={value?.toString()}
      onChangeText={text => mutateValue.mutateAsync(text)}
    />
  ) : (
    title + (value || '')
  );
  let right = !staticParam
    ? () => (
        <Button
          icon={icon}
          mode="outlined"
          onPress={() => {
            if (!isEditing)
              dispatch(
                setEditingParams({
                  [product?.id]: {[productKey]: true},
                }),
              );
            else
              dispatch(
                setEditingParams({
                  [product?.id]: {[productKey]: false},
                }),
              );
          }}>
          {'Edit'}
        </Button>
      )
    : undefined;
  if (isFileSelector) {
    right = () => (
      <Button
        icon={icon}
        mode="outlined"
        onPress={async () => {
          const pickerResult =
            (await DocumentPicker.pickSingle()) as DocumentPickerAsset & {
              file: File;
              type: string;
            };
          const pinned = await pinFileToIPFS(pickerResult.file);
          const link = 'https://ipfs.io/ipfs/' + pinned.IpfsHash;
          console.info('product on save logo', product);
          product[productKey] = link;
          await writeItem({...product, service: undefined});
        }}>
        {'Upload Image'}
      </Button>
    );
  }
  return <List.Item title={titleParam} left={left} right={right} />;
}
